import dayjs from 'dayjs'
import React from 'react'
import ReactDatePicker from 'react-datepicker'
import Flex from '../Flex'
import Icon from '../Icon'
import Text from '../Text'
import { DatePickerRangeProps, RangeDatePickerHeaderProps } from './DatePicker.types'
import { RangePickerWrapper } from './styled'

export const RangeDatePickerHeader = ({
  decreaseMonth,
  increaseMonth,
  monthDate,
  customHeaderCount,
}: RangeDatePickerHeaderProps) => {
  return (
    <Flex
      alignItems='center'
      width='100%'
      justifyContent={customHeaderCount === 0 ? 'space-start' : 'flex-end'}
      columnGap='66px'
      marginBottom={24}
      cursor='pointer'
    >
      {customHeaderCount === 0 && (
        <Icon name='Left-outline' size={20} color='black50' onClick={decreaseMonth} />
      )}
      <Flex color='black100' columnGap='8px'>
        <Text variant='body'>{dayjs(monthDate).format('MMMM')}</Text>
        <Text variant='body' weight='bold'>
          {dayjs(monthDate).format('YYYY')}
        </Text>
      </Flex>
      {customHeaderCount === 1 && (
        <Icon name='Right-outline' size={20} color='black50' onClick={increaseMonth} />
      )}
    </Flex>
  )
}

const RangeDatePicker: React.FC<DatePickerRangeProps> = ({ ...props }) => {
  return (
    <RangePickerWrapper>
      <ReactDatePicker
        selectsRange
        monthsShown={2}
        renderCustomHeader={RangeDatePickerHeader}
        {...props}
      />
    </RangePickerWrapper>
  )
}

export default RangeDatePicker
